<template>
  <div class="margin-top">
    <v-row align="center" justify="center" class="fill-height ma-0">
      <v-col cols="12" class="text-center">
        <ResHubLogo height="250" />
        <h2 class="font-weight-bold pt-8 pb-4 ml-8">
          Please wait, loading
          <span class="dots" aria-hidden="true">{{ dotsPadded }}</span>
        </h2>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import ResHubLogo from "@/views/login/ResHubLogo.vue";
import "firebase/auth";

export default {
  name: "PcsAuth",
  components: {
    ResHubLogo
  },
  data() {
    return {
      dotsCount: 0,
      intervalId: null
    };
  },
   computed: {
    dotsPadded() {
      return '.'.repeat(this.dotsCount).padEnd(3, ' ');
    }
  },
  created() {
    this.pcsSignInWithCustomToken();
  },
  mounted() {
    this.intervalId = setInterval(() => {
      this.dotsCount = (this.dotsCount + 1) % 4;
    }, 500);
  },
  methods: {
    async pcsSignInWithCustomToken() {
        const token = this.$route.params.token;

        if (!token) {
          const tokenError = 'Missing token in callback URL'
          this.$toast.open({message: tokenError, type: "error"});
          throw new Error(tokenError);
        }

        try {
          await this.$store.dispatch("signInByCustomToken", {  customToken: token })
          this.$router.push("/");
        } catch (error) {
          const authError = 'Authentication failed. The token may be invalid or expired'
          this.$toast.open({message: authError, type: "error"});
          throw new Error(authError);
        }
    }
  }
};
</script>

<style scoped>
.login-form{
  max-width: 450px;
}

.dots {
  display: inline-block;
  width: 3ch;
  white-space: pre;
}

.margin-top{
  margin-top: 35vh;
  transform: translateY(-50%); 
}

@media (max-height: 520px) {
  .margin-top { margin-top: 16px; transform: none; }
}
</style>